<template>
  <div
    class="owal-banner__container"
    :class="{shadow}"
    >
    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DomainPreferences } from '@/libraries/permissions/domainPreferences'

export default {
  name: 'OwalBanner',
  /**
   * @prop {Boolean} shadow Does the banner cast a drop shadow?
   */
  props: {
    shadow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      currentDomain: 'currentDomain',
      preferences: 'preferences',
    }),
    numOfAlertsSources () {
      let alertSources = this.preferences[DomainPreferences.ALERTS_SOURCE]
      return Array.isArray(alertSources) ? alertSources.length : 1
    },
  },
}
</script>

<style scoped>
.owal-banner__container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  background: #d8d8d8;
  border: 1px solid #475669;
  border-radius: 5px;
  margin: 0.5714285715rem 0;
  padding: 0;
}

.shadow {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.2);
}
</style>
